import type { AuthEvent } from './token-store.ts'

export interface CrossTabAuth {
  broadcast(event: AuthEvent): void
  close(): void
}

/**
 * Signing out in one tab must sign out in the others: otherwise a second tab keeps a token
 * the user believes they gave up, and every request it makes succeeds.
 */
export function createCrossTabAuth(
  onRemoteEvent: (event: AuthEvent) => void,
  channelName = 'taler.auth',
): CrossTabAuth {
  if (typeof BroadcastChannel === 'undefined') {
    return { broadcast: () => {}, close: () => {} }
  }
  const channel = new BroadcastChannel(channelName)
  channel.onmessage = (message: MessageEvent<AuthEvent>) => onRemoteEvent(message.data)
  return {
    broadcast: (event) => channel.postMessage(event),
    close: () => channel.close(),
  }
}
